import { PageHeader } from "../components/shared";
import { OrgProfile } from "../components/OrgProfile";

export default function Organisation() {
  return (
    <div data-testid="organisation-page">
      <PageHeader eyebrow="Settings" title="Organisation details" desc="Your address, PF/ESIC employer codes, HR/IR manager and compliance inbox emails, and the letterhead used on your documents." />
      <OrgProfile />
    </div>);
}
